<template>
  <div class="Beneficiary-manager-container">
    <el-card class="box-card">
      <div slot="header" class="clearfix">
        <span><i class="el-icon-sold-out"></i> Beneficiaries</span>
        <el-button style="margin-right:10px;padding: 3px 0; vertical-align: -webkit-baseline-middle;float:right" icon="el-icon-plus" type="text" @click="addBeneficiary('international')">International Beneficiary</el-button>
        <el-button style="margin-right:10px;padding: 3px 0; vertical-align: -webkit-baseline-middle;float:right" icon="el-icon-plus" type="text" @click="addBeneficiary('domistic')">Domistic Beneficiary</el-button>
      </div>
      <data-tables 
        v-loading="loading" 
        :data="dataBeneficiaryTable" 
        border 
        :page-size="10"
        :pagination-props="{ background: true, pageSizes: [10, 20, 50, 100] }">
        <el-table-column prop="type" label="Type" header-align="center" align="center" fixed></el-table-column>
        <el-table-column prop="currency" label="Currency" header-align="center" align="center">
          <template slot-scope="scope">
            {{ scope.row.currency.toUpperCase() }}
          </template>
        </el-table-column>
        <el-table-column prop="name" label="Name" header-align="center" align="center"></el-table-column>
        <el-table-column prop="accountnumber" label="Account number" header-align="center" align="center"></el-table-column>
        <el-table-column prop="sortcode" label="Sortcode" header-align="center" align="center"></el-table-column>
        <el-table-column prop="bic" label="BIC" header-align="center" align="center"></el-table-column>
        <el-table-column prop="iban" label="IBAN" header-align="center" align="center"></el-table-column>
        <el-table-column prop="beneficiary_id" label="Action" header-align="center" align="center" width="200">
          <template slot-scope="scope">

              <el-button icon="el-icon-edit" type="warning" size="mini" @click="getBeneficiaryToEdit(scope.row.beneficiary_id)">Edit</el-button>
              <el-button icon="el-icon-delete" type="danger" size="mini" @click="deleteBeneficiary(scope.row.beneficiary_id)">Del</el-button>

          </template>
        </el-table-column>
      </data-tables>
    </el-card>

    <BeneficiaryCompanyForm ref="BeneficiaryCompanyForm" v-show="formEditType === 'company'" v-on:on-submited="submited"/>
    <BeneficiaryPersonForm ref="BeneficiaryPersonForm"  v-show="formEditType === 'person'" v-on:on-submited="submited"/>

    <el-dialog
      title="Add Beneficiary"
      :visible.sync="dialogAddFormVisible"
      :close-on-click-modal="false"
      :width="device === 'mobile' ? '95%' : '80%'"
      :before-close="handleClose"
      top="5vh"
    >
      <el-form ref="form" label-width="120px" size="small">
        <el-form-item label="Form Type">
          <el-select v-model="formType">
            <el-option label="Person" value="person"></el-option>
            <el-option label="Company" value="company"></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      
      <AddBeneficiaryCompanyForm ref="AddBeneficiaryCompanyForm"  v-show="formType === 'company'" :projectUID="projectUID" v-on:closed="handleClose()" v-on:submited="submited"/>
      <AddBeneficiaryPersonForm ref="AddBeneficiaryPersonForm" v-show="formType === 'person'" :projectUID="projectUID" v-on:closed="handleClose()" v-on:submited="submited"/>
    </el-dialog>



  </div>
</template>

<script>
import BeneficiaryCompanyForm from './company-form'
import BeneficiaryPersonForm from './person-form'
import AddBeneficiaryCompanyForm from './add-beneficiary-project-company'
import AddBeneficiaryPersonForm from './add-beneficiary-project-person'

import {getBeneficiaryByProject, getBeneficiaryBy, delBeneficiary} from '@/api/beneficiary'
export default {
  components:{
    BeneficiaryCompanyForm,
    BeneficiaryPersonForm,
    AddBeneficiaryCompanyForm,
    AddBeneficiaryPersonForm
  },
  props:{
    projectUID: String
  },
  computed: {
    device() {
      return this.$store.state.app.device;
    },
  },
  data(){
    return{
      loading:false,
      dialogFormVisible: false,
      dialogAddFormVisible: false,
      beneficiaryEditID: '',
      dataBeneficiaryTable: [],
      formType: "person",
      formEditType: "",
      swiftfx: ""
    }
  },
  methods:{
    getBeneficiaryData(){
      this.loading = true
      getBeneficiaryByProject(this.projectUID).then(({result, data})=>{
        this.loading = false
        if(result){
          this.dataBeneficiaryTable = data
        }
      })
    },
    getBeneficiaryToEdit(beneficiary_id){
      const loading = this.$notifyloading("Loading data...");
      getBeneficiaryBy(beneficiary_id).then(({ result, data }) => {
        loading.close();
        if (result) {
          this.formEditType = data.type
          setTimeout(()=>{
            this.formEditType === "company" && this.$refs.BeneficiaryCompanyForm.setModel(beneficiary_id, data);
            this.formEditType === "person" && this.$refs.BeneficiaryPersonForm.setModel(beneficiary_id, data);
          }, 400)
        }
      });
    },
    deleteBeneficiary(beneficiary_id){
            this.$confirm('Are you sure you want to delete this Beneficiary, Continue?', 'Warning', {
          confirmButtonText: 'OK',
          cancelButtonText: 'Cancel',
          type: 'warning'
        }).then(() => {
          delBeneficiary(beneficiary_id).then(({ result, message}) =>{
            if(result){
              this.$notify({
                title: 'Success',
                message: `Delete Beneficiary successfully`,
                type: 'success',
                duration: 2000
              });
              this.getBeneficiaryData()
            }
          })
        }).catch(() => {
          this.$message({
            type: 'info',
            message: 'Delete canceled'
          });          
        });
    },

    addBeneficiary(swifttype){
      this.dialogAddFormVisible = true;
      this.formType = 'person'
      setTimeout(()=>{
        this.$refs.AddBeneficiaryCompanyForm.setModel(swifttype);
        this.$refs.AddBeneficiaryPersonForm.setModel(swifttype);
      }, 400)
          
      
    },
    handleClose() {
      this.dialogAddFormVisible = false;
    },

    submited(){
      this.getBeneficiaryData()
    }
  },
  created(){
    this.getBeneficiaryData()
  }
}
</script>

<style>

</style>